var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonsterIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 106,
    viewBox: "0 0 86 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12387_385807)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 106,
    fill: "#9E1107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7561 -11.4026C87.2012 -15.6663 86.9592 4.24856 75.0807 27.2629C63.0638 50.541 62.3574 50.7328 76.0042 57.776C97.519 68.8781 113.036 -5.22891 97.7561 -11.4026Z",
    fill: "#FF122F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M96.7484 -6.93315C87.8697 -10.519 87.6667 6.23262 77.6719 25.5922C67.5673 45.1737 66.9705 45.3344 78.449 51.2575C96.5482 60.5979 109.601 -1.74047 96.7484 -6.93315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-38.1324 67.0523C-36.5483 55.7801 -19.1814 65.5284 6.69052 66.7476C32.8584 67.9797 33.3769 67.4643 32.6522 82.8049C31.5104 106.988 -40.4277 83.3731 -38.1324 67.0523Z",
    fill: "#FF122F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M-33.7597 68.4153C-32.4258 58.9332 -17.817 67.1332 3.94627 68.1572C25.9583 69.1962 26.3942 68.7607 25.7845 81.6628C24.8257 102.006 -35.6892 82.1427 -33.7597 68.4153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5283 33.6538C79.7971 8.13852 42.6721 -8.39511 17.1538 6.33789C-8.3628 21.0699 -12.6076 61.4884 2.12364 87.0036C12.3246 104.672 32.359 116.465 48.3033 110.422C55.3843 107.739 56.5843 92.754 64.4307 88.2239C72.7538 83.4185 86.7337 89.6016 92.7713 84.4805C95.0575 82.54 96.8985 80.1809 98.3198 77.517C104.645 65.6448 102.635 47.6947 94.5283 33.6538Z",
    fill: "#FF122F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-31.6019 29.0048C-31.1207 29.3486 -30.5777 29.6661 -30.0008 29.9685C-30.0024 29.9717 -30.0036 29.9736 -30.0066 29.9764C-15.3155 38.2611 -0.0489411 42.2534 10.6868 36.0551C18.7004 31.4284 23.2345 21.834 25.028 10.2238C21.811 8.16125 10.9356 2.88057 3.05942 3.57698C6.03457 4.69315 6.93737 5.0545 9.05042 6.85916C0.0492839 7.06623 -11.505 9.669 -20.2966 17.2041C-12.4298 13.5275 -9.72593 14.1717 -7.60027 14.5809C-11.6848 17.0552 -22.2572 17.7258 -30.1149 26.0146C-28.6383 25.1861 -22.6469 21.6949 -20.1582 22.1875C-20.7686 22.8939 -29.9318 25.8261 -31.6019 29.0048Z",
    fill: "#FF122F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25.7297 36.4068C-25.2111 36.2579 -24.65 36.1489 -24.0612 36.064C-24.0609 36.0604 -24.0619 36.0587 -24.0621 36.0565C-8.92371 33.3771 5.41027 34.5638 12.7642 43.1428C18.253 49.5442 19.2471 59.1669 17.2743 69.6901C13.8829 70.4886 2.93374 71.7388 -3.62689 68.7579C-0.729388 68.6985 0.154356 68.6606 2.51775 67.7477C-5.1578 64.8463 -14.3039 59.1131 -19.5819 49.9733C-13.9307 55.5155 -11.412 55.7794 -9.45881 56.0709C-12.2227 52.7091 -21.1092 48.9324 -25.3554 39.4279C-24.3365 40.5876 -20.2432 45.4021 -17.9533 45.7314C-18.2657 44.9395 -25.2563 39.6454 -25.7297 36.4068Z",
    fill: "#FF122F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1631 -24.5529C61.2194 -23.9637 61.222 -23.3342 61.1963 -22.6839C61.199 -22.6832 61.203 -22.6843 61.2061 -22.685C61.0361 -5.8203 56.8603 9.39708 46.1245 15.5953C38.1109 20.222 27.534 19.3519 16.5816 15.1005C16.4056 11.2823 17.2701 -0.776439 21.8105 -7.24871C21.2887 -4.11356 21.1519 -3.15205 21.6583 -0.419757C26.3382 -8.11143 34.3694 -16.8163 45.2908 -20.6626C38.1733 -15.688 37.3793 -13.0243 36.67 -10.9783C40.8542 -13.278 46.722 -22.0991 57.83 -24.7602C56.3743 -23.8956 50.3542 -20.4521 49.5373 -18.051C50.4543 -18.2265 57.5744 -24.6954 61.1631 -24.5529Z",
    fill: "#FF122F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6371 -15.7663C64.2498 -15.3922 63.8739 -14.9603 63.5078 -14.4937C63.5045 -14.4953 63.5035 -14.497 63.5008 -14.4978C53.6113 -2.72726 47.4728 10.2791 51.2255 20.9374C54.0241 28.892 61.8605 34.5643 71.9611 38.1169C74.3475 35.5796 80.9056 26.7219 81.6035 19.5503C80.1033 22.0299 79.6295 22.7758 77.6555 24.3671C78.9822 16.2682 78.5885 5.48181 73.313 -3.65947C75.288 4.00529 74.2563 6.31897 73.5331 8.15575C72.0018 4.08225 73.1761 -5.50301 67.0681 -13.9326C67.5629 -12.4704 69.6858 -6.51823 68.826 -4.37049C68.2939 -5.03545 67.206 -13.7376 64.6371 -15.7663Z",
    fill: "#FF122F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M67.3055 16.3051C67.0223 11.8214 65.9046 7.08275 63.4325 2.8009C64.9955 8.86827 64.1792 10.6991 63.6052 12.1532C62.3951 8.92859 63.3245 1.34177 58.4898 -5.32814C58.8807 -4.17135 60.5603 0.539317 59.8811 2.23925C59.4615 1.71155 58.5997 -5.17556 56.5677 -6.78221C56.2591 -6.48456 55.9618 -6.14165 55.6705 -5.77235L55.6675 -5.77752C54.7776 -4.71906 53.9268 -3.64866 53.1211 -2.56984C53.5853 -5.65559 53.8169 -8.9151 53.8506 -12.2568C53.8466 -12.2557 53.8461 -12.2565 53.843 -12.2559C53.8647 -12.7718 53.8616 -13.2687 53.8167 -13.7347C50.9758 -13.8481 45.3399 -8.72791 44.6147 -8.5885C45.2605 -10.4897 50.0265 -13.215 51.1792 -13.8977C42.3873 -11.7935 37.7438 -4.8112 34.432 -2.99106C34.993 -4.61121 35.6197 -6.71864 41.2548 -10.6558C32.6102 -7.61159 26.2529 -0.721199 22.5487 5.36599C22.1505 3.20329 22.2583 2.44238 22.6708 -0.0401119C20.6645 2.81901 19.5675 7.04812 19.0119 10.7578C15.5206 9.3846 11.307 8.22153 7.82954 8.52847C10.1848 9.413 10.8994 9.69915 12.5715 11.1263C5.44777 11.2906 -3.69728 13.3505 -10.6576 19.3158C-4.42956 16.4038 -2.29025 16.9143 -0.605811 17.238C-3.83886 19.1966 -12.2084 19.7273 -18.4258 26.2887C-17.2581 25.6318 -12.5167 22.8679 -10.5456 23.2583C-11.0306 23.8176 -18.2827 26.1383 -19.6033 28.6544C-19.2231 28.9268 -18.7934 29.1774 -18.3358 29.4165C-18.337 29.4184 -18.3382 29.4203 -18.3403 29.4226C-15.4295 31.0643 -12.4909 32.4935 -9.58732 33.6349C-10.9245 33.7932 -12.2768 33.9949 -13.6376 34.2358C-13.6379 34.2371 -13.6369 34.2388 -13.6354 34.2414C-14.1018 34.3096 -14.5466 34.3951 -14.9569 34.5125C-14.5824 37.0762 -9.04969 41.2665 -8.80163 41.8932C-10.6143 41.632 -13.8541 37.8221 -14.6613 36.9057C-11.2997 44.4261 -4.26549 47.4151 -2.07964 50.0764C-3.62429 49.8454 -5.61796 49.637 -10.0918 45.2502C-7.38531 49.938 -3.39215 53.4922 0.735446 56.0391C1.04753 67.0841 3.94871 78.2581 9.24178 87.426C23.147 111.51 40.7462 99.5534 63.4157 86.4651C86.0862 73.3764 105.241 64.1135 91.3357 40.029C85.8371 30.5052 77.1723 22.136 67.3055 16.3051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.9,
    cx: 45.8982,
    cy: 54.3178,
    rx: 49.1546,
    ry: 30.4492,
    transform: "rotate(-30 45.8982 54.3178)",
    fill: "url(#paint0_radial_12387_385807)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2579 40.9668C89.728 45.2451 88.2624 50.7168 83.9827 53.1876L25.0204 87.2296C20.7408 89.7004 15.2693 88.2339 12.7992 83.9555C10.3291 79.6771 11.7947 74.2055 16.0744 71.7346L75.0367 37.6927C79.3164 35.2218 84.7878 36.6884 87.2579 40.9668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6509 36.493C34.8348 43.7398 32.3536 53.0062 25.1063 57.1905C17.8581 61.3753 8.59161 58.8913 4.40771 51.6446C0.223313 44.397 2.70586 35.1309 9.95407 30.9461C17.2014 26.7618 26.4665 29.2454 30.6509 36.493Z",
    fill: "#DA4854"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8031 36.9809C33.7162 43.7585 31.3935 52.4254 24.6153 56.3388C17.837 60.2522 9.17001 57.9303 5.25692 51.1527C1.34384 44.375 3.66652 35.7082 10.4448 31.7947C17.223 27.8813 25.8901 30.2032 29.8031 36.9809Z",
    fill: "url(#paint1_radial_12387_385807)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1336 40.2555C26.2387 43.9016 24.9892 48.564 21.3428 50.6693C17.6963 52.7746 13.0338 51.5255 10.9287 47.8793C8.82364 44.2332 10.0731 39.5708 13.7196 37.4655C17.366 35.3603 22.0285 36.6094 24.1336 40.2555Z",
    fill: "url(#paint2_radial_12387_385807)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6183 42.285C21.603 43.9907 21.0186 46.1714 19.3137 47.1558C17.607 48.1411 15.4262 47.5569 14.4415 45.8512C13.4567 44.1455 14.0411 41.9648 15.7478 40.9795C17.4528 39.9951 19.6335 40.5794 20.6183 42.285Z",
    fill: "#2E2A49"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.6535,
    cy: 40.8034,
    rx: 4.24443,
    ry: 3.26182,
    transform: "rotate(-30 15.6535 40.8034)",
    fill: "url(#paint3_radial_12387_385807)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7644 17.9525C66.9488 25.2001 64.4676 34.4666 57.2176 38.6523C49.9703 42.8366 40.7038 40.3526 36.5194 33.105C32.335 25.8575 34.8176 16.5913 42.0649 12.4071C49.3149 8.22131 58.58 10.7049 62.7644 17.9525Z",
    fill: "#DA4854"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9144 18.4425C65.8276 25.2204 63.5049 33.8875 56.7265 37.801C49.9481 41.7145 41.2808 39.3925 37.3676 32.6147C33.4544 25.8368 35.7771 17.1697 42.5555 13.2562C49.334 9.34271 58.0012 11.6647 61.9144 18.4425Z",
    fill: "url(#paint4_radial_12387_385807)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2441 21.7158C58.3492 25.3619 57.0997 30.0243 53.4533 32.1296C49.8068 34.2349 45.1443 32.9858 43.0392 29.3397C40.9341 25.6936 42.1837 21.0311 45.8301 18.9259C49.4765 16.8206 54.1391 18.0697 56.2441 21.7158Z",
    fill: "url(#paint5_radial_12387_385807)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7283 23.7462C53.7136 25.4527 53.1291 27.6334 51.4242 28.6178C49.7183 29.6027 47.5384 29.0179 46.5532 27.3114C45.5684 25.6057 46.152 23.4255 47.8578 22.4407C49.5628 21.4563 51.7435 22.0405 52.7283 23.7462Z",
    fill: "#2E2A49"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.7606,
    cy: 22.2672,
    rx: 4.24443,
    ry: 3.26182,
    transform: "rotate(-30 47.7606 22.2672)",
    fill: "url(#paint6_radial_12387_385807)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8601 71.3783C11.5905 73.8434 10.1342 79.3279 12.5991 83.5972C15.0732 87.8826 20.5419 89.3476 24.8115 86.8825L83.7841 52.8347C88.0537 50.3696 89.5193 44.9011 87.0451 40.6158C84.5803 36.3465 79.1024 34.8654 74.8327 37.3305L15.8601 71.3783Z",
    fill: "url(#paint7_linear_12387_385807)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3425 71.688L16.0879 72.9791C16.7621 74.1469 18.2573 74.549 19.4253 73.8746C20.5949 73.1993 20.9935 71.704 20.3193 70.5361L19.5738 69.245L15.3425 71.688Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6737 71.4976L16.3027 72.587C16.871 73.5713 18.1313 73.9089 19.1165 73.3401C20.1026 72.7708 20.4404 71.5105 19.8721 70.5262L19.2431 69.4368L15.6737 71.4976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.88597,
    height: 1.43809,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 19.5711 69.2455)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9021 68.4786C20.9036 68.4812 20.9058 68.4869 20.9077 68.4903L21.6467 69.7702C22.321 70.9381 23.817 71.3396 24.9849 70.6653C26.1529 69.991 26.5531 68.4946 25.8789 67.3268L25.1399 66.0469C25.1379 66.0434 25.1341 66.0387 25.1326 66.0362L20.9021 68.4786Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2325 68.2876L21.8615 69.377C22.4298 70.3613 23.6892 70.6994 24.6744 70.1306C25.6596 69.5618 25.9982 68.301 25.4299 67.3168L24.801 66.2273L21.2325 68.2876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.8859,
    height: 1.43809,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 25.1316 66.0348)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4583 65.2701L27.2038 66.5612C27.878 67.7291 29.3732 68.1311 30.5429 67.4558C31.7108 66.7815 32.1103 65.2856 31.436 64.1178L30.6906 62.8267L26.4583 65.2701Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7922 65.0776C26.7928 65.0807 26.7948 65.0842 26.7968 65.0876L27.4203 66.1675C27.9886 67.1518 29.2489 67.4895 30.2341 66.9206C31.2193 66.3518 31.5571 65.0915 30.9888 64.1073L30.3653 63.0273C30.3633 63.0239 30.3605 63.0209 30.359 63.0183L26.7922 65.0776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.88698,
    height: 1.43709,
    transform: "matrix(0.866025 -0.5 -0.5 -0.866025 27.1778 66.5149)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0171 62.0607L32.7625 63.3518C33.4368 64.5196 34.932 64.9216 36.1016 64.2463C37.2696 63.572 37.669 62.0762 36.9947 60.9083L36.2493 59.6172L32.0171 62.0607Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3501 61.8691L32.9791 62.9586C33.5473 63.9428 34.8077 64.2805 35.7938 63.7111C36.779 63.1423 37.1168 61.882 36.5485 60.8977L35.9195 59.8083L32.3501 61.8691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.88692,
    height: 1.43709,
    transform: "matrix(0.866025 -0.5 -0.5 -0.866025 32.7366 63.3051)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5776 58.8508L38.3231 60.1419C38.9973 61.3098 40.4925 61.7118 41.6604 61.0375C42.8301 60.3622 43.2287 58.8668 42.5544 57.6989L41.809 56.4078L37.5776 58.8508Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9089 58.6598L38.5379 59.7492C39.1061 60.7335 40.3664 61.0711 41.3516 60.5023C42.3377 59.933 42.6755 58.6727 42.1072 57.6885L41.4782 56.599L37.9089 58.6598Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.88596,
    height: 1.43709,
    transform: "matrix(0.866025 -0.5 -0.5 -0.866025 38.2953 60.0952)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1364 55.6413C43.1379 55.6439 43.1392 55.6501 43.1412 55.6535L43.8801 56.9334C44.5544 58.1013 46.0513 58.5023 47.2184 57.8285C48.3889 57.1527 48.7875 55.6573 48.1132 54.4895L47.3678 53.1984L43.1364 55.6413Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4677 55.4498C43.4692 55.4524 43.4694 55.4568 43.4714 55.4603L44.0949 56.5402C44.6632 57.5245 45.9244 57.8616 46.9087 57.2933C47.8957 56.7235 48.2334 55.4632 47.6651 54.479L47.0362 53.3895L43.4677 55.4498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.88597,
    height: 1.43809,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 47.3651 53.1985)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6935 52.4325L49.4389 53.7236C50.1132 54.8914 51.6083 55.2935 52.778 54.6182C53.9459 53.9438 54.3462 52.4475 53.672 51.2796L52.933 49.9997C52.931 49.9963 52.9263 49.9921 52.9248 49.9895L48.6935 52.4325Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0265 52.2403C49.0262 52.2439 49.0282 52.2474 49.0302 52.2508L49.6537 53.3308C50.222 54.315 51.4823 54.6527 52.4684 54.0834C53.4536 53.5146 53.7913 52.2543 53.2231 51.27L52.5941 50.1806L49.0265 52.2403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.88787,
    height: 1.43709,
    transform: "matrix(0.866025 -0.5 -0.5 -0.866025 49.4129 53.6772)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2523 49.223L54.9977 50.5141C55.672 51.682 57.1671 52.084 58.3351 51.4097C59.5048 50.7344 59.9033 49.239 59.2291 48.0711L58.4837 46.78L54.2523 49.223Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5853 49.0315L55.2142 50.1209C55.7825 51.1052 57.0428 51.4428 58.0272 50.8745C59.0141 50.3047 59.3518 49.0444 58.7836 48.0602L58.1546 46.9707L54.5853 49.0315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.8859,
    height: 1.43809,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 58.4792 46.7817)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8111 46.0137L60.5565 47.3048C61.2307 48.4726 62.7259 48.8746 63.8938 48.2003C65.0644 47.5245 65.4629 46.0292 64.7887 44.8613L64.0433 43.5702L59.8111 46.0137Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.144 45.8225L60.773 46.9119C61.3413 47.8962 62.6016 48.2339 63.5859 47.6655C64.5729 47.0957 64.9106 45.8354 64.3424 44.8512L63.7134 43.7618L60.144 45.8225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.88597,
    height: 1.43709,
    transform: "matrix(0.866025 -0.5 -0.5 -0.866025 60.5305 47.2579)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3716 42.8038L66.117 44.0949C66.7913 45.2628 68.2864 45.6648 69.4535 44.991C70.6223 44.3162 71.0226 42.8198 70.3484 41.6519L69.6094 40.3721C69.6074 40.3686 69.6027 40.3644 69.6012 40.3618L65.3716 42.8038Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7028 42.6127L66.3318 43.7021C66.9001 44.6864 68.1604 45.024 69.1448 44.4557C70.13 43.8869 70.4695 42.6256 69.9012 41.6413L69.2777 40.5614C69.2757 40.5579 69.272 40.5555 69.2705 40.5529L65.7028 42.6127Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.88596,
    height: 1.43809,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 69.5985 40.3617)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9304 39.5942C70.9319 39.5968 70.9331 39.603 70.9351 39.6064L71.6741 40.8863C72.3483 42.0542 73.8452 42.4552 75.0132 41.7809C76.1811 41.1065 76.5797 39.6112 75.9054 38.4433L75.16 37.1522L70.9304 39.5942Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2616 39.4033L71.8906 40.4927C72.4589 41.477 73.7183 41.8152 74.7036 41.2463C75.6888 40.6775 76.0257 39.4177 75.4574 38.4334L74.8284 37.344L71.2616 39.4033Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.88394,
    height: 1.43809,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 75.159 37.1519)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3878 87.1239L23.6434 85.8346C22.9681 84.665 23.3685 83.1708 24.5365 82.4965C25.7062 81.8212 27.1995 82.222 27.8748 83.3916L28.6192 84.6809L24.3878 87.1239Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7164 86.9335L24.0884 85.8458C23.5191 84.8598 23.8569 83.5995 24.8421 83.0307C25.8282 82.4614 27.0885 82.799 27.6577 83.785L28.2857 84.8727L24.7164 86.9335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.88597,
    height: 1.4381,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 27.8972 83.4368)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9457 83.9145C29.9442 83.9119 29.9414 83.9089 29.9394 83.9055L29.2004 82.6256C28.5252 81.456 28.9265 79.9614 30.0944 79.287C31.2633 78.6122 32.7574 79.0125 33.4327 80.1821L34.1771 81.4715L29.9457 83.9145Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2786 83.7228L29.6506 82.6351C29.0814 81.6491 29.4182 80.3893 30.4035 79.8205C31.3895 79.2512 32.6498 79.5888 33.2191 80.5748L33.8426 81.6548C33.8436 81.6565 33.8439 81.6609 33.8454 81.6635L30.2786 83.7228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.88597,
    height: 1.43809,
    transform: "matrix(0.866025 -0.5 -0.5 -0.866025 29.9468 83.9141)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5045 80.7055C35.503 80.7029 35.5002 80.6999 35.4982 80.6965L34.7592 79.4166C34.084 78.247 34.4852 76.7524 35.654 76.0776C36.822 75.4033 38.317 75.8031 38.9923 76.9726L39.7312 78.2525C39.7332 78.256 39.7344 78.2599 39.7358 78.2625L35.5045 80.7055Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8365 80.5138C35.8342 80.5117 35.8322 80.5082 35.8312 80.5065L35.2077 79.4266C34.6384 78.4406 34.9771 77.1798 35.9614 76.6115C36.9466 76.0426 38.2078 76.3798 38.7771 77.3658L39.4006 78.4457C39.4016 78.4474 39.4027 78.4514 39.4042 78.454L35.8365 80.5138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.88692,
    height: 1.4381,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 39.02 77.0156)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0624 77.4967L40.318 76.2074C39.6427 75.0378 40.0449 73.5427 41.2128 72.8683C42.3817 72.1935 43.875 72.5943 44.5502 73.7639L45.2947 75.0533L41.0624 77.4967Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3936 77.3048C41.3913 77.3027 41.3893 77.2992 41.3883 77.2975L40.7648 76.2176C40.1955 75.2316 40.5341 73.9708 41.5193 73.402C42.5045 72.8332 43.7648 73.1708 44.3341 74.1568L44.9621 75.2445L41.3936 77.3048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.8859,
    height: 1.43809,
    transform: "matrix(0.866025 -0.5 -0.5 -0.866025 41.0627 77.4958)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6212 74.2868L45.8768 72.9974C45.2015 71.8278 45.602 70.3337 46.7699 69.6594C47.9396 68.9841 49.4329 69.3848 50.1082 70.5544L50.8526 71.8438L46.6212 74.2868Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9533 74.0958L46.3253 73.0081C45.756 72.0221 46.0938 70.7618 47.079 70.193C48.0651 69.6237 49.3254 69.9613 49.8947 70.9473L50.5227 72.035L46.9533 74.0958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.88596,
    height: 1.4381,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 50.1393 70.5955)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1817 71.0769L51.4373 69.7876C50.7621 68.618 51.1625 67.1239 52.3296 66.45C53.4984 65.7752 54.9934 66.175 55.6687 67.3446L56.4131 68.634L52.1817 71.0769Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.512 70.886L51.8841 69.7983C51.3148 68.8123 51.6525 67.552 52.636 66.9842C53.6221 66.4149 54.8833 66.752 55.4525 67.738L56.076 68.818C56.077 68.8197 56.0773 68.8241 56.0788 68.8267L52.512 70.886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.8859,
    height: 1.4381,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 55.6912 67.3905)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7405 67.8678C57.739 67.8652 57.7353 67.8628 57.7333 67.8593L56.9944 66.5794C56.3191 65.4099 56.7213 63.9147 57.8893 63.2404C59.0572 62.5661 60.5505 62.9668 61.2258 64.1364L61.9702 65.4258L57.7405 67.8678Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0725 67.676C58.0711 67.6734 58.0673 67.6709 58.0663 67.6692L57.4428 66.5893C56.8736 65.6033 57.213 64.342 58.1974 63.7737C59.1826 63.2049 60.4429 63.5425 61.0122 64.5285L61.6402 65.6162L58.0725 67.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.88394,
    height: 1.4381,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 61.2517 64.1802)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2976 64.6595L62.5532 63.3701C61.8779 62.2005 62.2783 60.7064 63.448 60.0311C64.6168 59.3562 66.1101 59.757 66.7854 60.9266L67.5298 62.216L63.2976 64.6595Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6314 64.4665C63.6299 64.4639 63.6261 64.4615 63.6252 64.4598L63.0016 63.3798C62.4324 62.3938 62.7719 61.1325 63.7562 60.5642C64.7415 59.9954 66.0018 60.333 66.571 61.319L67.199 62.4067L63.6314 64.4665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.88596,
    height: 1.43809,
    transform: "matrix(0.866025 -0.5 -0.5 -0.866025 63.2978 64.6584)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8564 61.4496L68.1119 60.1602C67.4367 58.9907 67.8371 57.4965 69.0059 56.8217C70.1747 56.1469 71.668 56.5477 72.3432 57.7173L73.0877 59.0067L68.8564 61.4496Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1867 61.2582L68.5587 60.1705C67.9895 59.1845 68.3272 57.9242 69.3133 57.3549C70.2985 56.786 71.5588 57.1237 72.1281 58.1097L72.7561 59.1974L69.1867 61.2582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.88603,
    height: 1.4381,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 72.3727 57.7592)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4169 58.2396C74.4154 58.2371 74.4117 58.2346 74.4097 58.2312L73.6707 56.9513C72.9955 55.7817 73.3976 54.2866 74.5656 53.6122C75.7353 52.9369 77.2286 53.3377 77.9039 54.5073L78.6483 55.7966L74.4169 58.2396Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7472 58.0487L74.1192 56.961C73.55 55.975 73.8877 54.7147 74.8729 54.1459C75.859 53.5766 77.1194 53.9142 77.6886 54.9002L78.3166 55.9879L74.7472 58.0487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.8859,
    height: 1.4381,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 77.9246 54.5537)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9739 55.0312L79.2295 53.7418C78.5543 52.5722 78.9547 51.0781 80.1244 50.4028C81.2923 49.7285 82.7873 50.1282 83.4626 51.2978L84.207 52.5872L79.9739 55.0312Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3077 54.8383C80.3045 54.8367 80.3025 54.8333 80.3015 54.8316L79.678 53.7516C79.1087 52.7656 79.4474 51.5048 80.4326 50.936C81.4178 50.3672 82.679 50.7043 83.2483 51.6903L83.8718 52.7703C83.8728 52.772 83.873 52.7764 83.8745 52.779L80.3077 54.8383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.88793,
    height: 1.43809,
    transform: "matrix(0.866025 -0.5 -0.5 -0.866025 79.9725 55.0311)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1686 8.86468C34.0064 10.4484 35.939 10.9662 37.5973 10.213C38.8999 9.63955 40.7228 7.66822 42.9478 5.46476C45.697 2.75446 49.0588 -0.309547 52.7113 -1.49945C41.7495 -0.147856 36.1203 3.58711 34.5172 4.43605C34.4981 4.44711 34.4598 4.46921 34.4215 4.49132C32.9091 5.36453 32.3418 7.30006 33.1686 8.86468Z",
    fill: "url(#paint8_linear_12387_385807)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.81674 20.4298C5.28002 21.3936 -0.769137 24.4011 -7.42055 33.2185C-4.56382 30.6503 -0.229416 29.2709 3.49235 28.2452C6.51307 27.42 9.13175 26.827 10.2797 25.9856C11.7611 24.9261 12.279 22.9935 11.3264 21.4761C10.3847 19.9778 8.4249 19.5013 6.91246 20.3745C6.87417 20.3966 6.83588 20.4187 6.81674 20.4298Z",
    fill: "url(#paint9_linear_12387_385807)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_12387_385807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.8982 54.3178) rotate(90) scale(30.3901 49.1546)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40414,
    stopColor: "white",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681066,
    stopColor: "#EC8F3A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC8F3A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_12387_385807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.5298 44.0678) rotate(-30) scale(14.1718 14.1705)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_12387_385807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.5311 44.0678) rotate(-30) scale(7.62386 7.62319)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#73B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_12387_385807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.6535 47.6711) rotate(-90) scale(10.1295 13.181)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#2E2A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#2E2A49",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760417,
    stopColor: "#B0C5FB",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_12387_385807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.641 25.5288) rotate(-30) scale(14.1721 14.1709)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_12387_385807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.6413 25.5292) rotate(-30) scale(7.62386 7.62319)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#73B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_12387_385807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.7606 29.1348) rotate(-90) scale(10.1295 13.181)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#2E2A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#2E2A49",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760417,
    stopColor: "#B0C5FB",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12387_385807",
    x1: 17.344,
    y1: 91.8145,
    x2: 8.07754,
    y2: 75.7646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12387_385807",
    x1: 27.7032,
    y1: -0.601635,
    x2: 46.848,
    y2: -11.6549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_12387_385807",
    x1: 5.86101,
    y1: 12.0098,
    x2: -13.2838,
    y2: 23.0631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12387_385807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 106,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonsterIcon4);
export default __webpack_public_path__ + "static/media/MonsterIcon4.19a3814f7c55d94e486de81fcd242975.svg";
export { ForwardRef as ReactComponent };